import {
  Box,
  Grid,
  Button,
  Select,
  Backdrop,
  CircularProgress,
  Divider,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { centralAdminUrls } from "../centralAdminUtils";
import axios from "axios";
import {
  GetUserCountries,
  GetRoles,
  DeleteUsers,
  SaveUser,
  setState,
} from "../centralAdminSlice";
import MultiSelectCountry from "./MultiSelectCountry_updated";
import { DataGridPro } from "@mui/x-data-grid-pro";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import EditUser from "./EditUsersModal";
import AddUserModal from "./AddUserModal";
import SharedComponent from "../SharedComponent";
import CollapseSection from "../../../components/ui/CollapseSection";
import muiConfig from '../../../assets/MuiConfig.json'

export default function ManageUsers() {
  const dispatch = useDispatch();
  const centralAdmin = useSelector((state) => state.centralAdmin);
  const {
    countries,
    selectedCountry,
    selectedCountryID,
    roles,
    selectedRole,
    selectedRoleID,
    getUserDataInitially,
    clearUserAdminData
  } = centralAdmin;

  const loginState = useSelector((store) => store.login);
  const { globalSelectedCountryName,globalSelectedCountryID,} = loginState  

  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState(null);
  const [selectedRowID, setSelectedRowID] = useState([]);

  const [showButton, setShowButton] = useState(false);
  const [getUserData, setGetUserData] = useState();

  const [quantiRoleChange, setQuantiRoleChange] = useState({
    roleChanged: false,
    rowId: 0,
  });

  useEffect(() => {
    if(globalSelectedCountryName !==null && globalSelectedCountryName !== "" ){
      dispatch(setState("selectedCountry", globalSelectedCountryName));
      dispatch(setState("selectedCountryID", globalSelectedCountryID));
    }
    else{
    dispatch(setState("selectedCountry", "All"));
    dispatch(setState("selectedCountryID", null));
    }

    dispatch(setState("selectedRole", "All"));
    dispatch(setState("selectedRoleID", 0));
    dispatch(setState("clearUserAdminData", true));

    displayDataInGrid();
  }, [getUserDataInitially]);

  useEffect(() => {
    if (countries.length <= 0) {
      dispatch(GetUserCountries({ method: "Get" }));
    }
  }, [searchText]);

  useEffect(() => {
    if (roles.length <= 0) {
      dispatch(GetRoles({ method: "Get" }));
    }
  }, [searchText]);

  async function displayDataInGrid() {

  if (selectedCountryID === 0) {
    await dispatch(setState("selectedCountryID", null));
  }

  let baseUrl =
    centralAdminUrls.getUsers +
    "RoleID=" +
    selectedRoleID +
    "&CountryID=" +
    selectedCountryID +
    "&searchText=" +
    searchText;

  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  const token = data.token;

  setIsLoading(true);

  try {
    const response = await axios.get(baseUrl, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });

    const responseData = response.data;
    const countryIDList=countries.map(country=>country.countryID).join(",");
    //console.log("The response data is",responseData);
    //console.log("the countries are",countries);

    if (responseData.length >0){
      responseData.forEach((item)=>{
        if(item.geoID ===""){
          item.geoID=countryIDList;
        }
      });
    }
    setGetUserData(responseData);
  } catch (error) {
    console.error("Error fetching user data:", error);
  } finally {
    setIsLoading(false);
  }
}

  const handleSearchText = (e) => {
    const value = e.target.value;
    setSearchText(value);
  };

  const handleCountryChange = (e) => {
    dispatch(setState("clearUserAdminData", false));
    const name = e.target.value;
    let countryID = 0;
    if (name !== "All") {
      countryID = countries.find(
        (country) => country.countryName === name
      ).countryID;
    }
    if(name==="All"){
    countryID=null;
    }

    dispatch(setState("selectedCountry", name));
    dispatch(setState("selectedCountryID", countryID));
  };

  const handleRoleChange = (e) => {
    dispatch(setState("clearUserAdminData", false));
    const name = e.target.value;
    let id = 0;
    if (name !== "All") {
      id = roles.find((c) => c.roleName === name).roleID;
    }

    dispatch(setState("selectedRole", name));
    dispatch(setState("selectedRoleID", id));
  };

  const handleDisplay = () => {
    setGetUserData([]);
    setQuantiRoleChange({ roleChanged: false, rowId: null });
    //  Admin/GetUsers?RoleID=0&CountryID=2&searchText=alina
    if (!selectedCountry) {
      dispatch(setState("isFailed_Info", "Please select a country."));
      dispatch(setState("isFailed", true));
      return;
    }

    if (!selectedRole) {
      dispatch(setState("isFailed_Info", "Please select a role."));
      dispatch(setState("isFailed", true));
      return;
    }
    dispatch(setState("clearUserAdminData", true));
    displayDataInGrid();

  };

  const handleDeactivateUser = () => {
    dispatch(DeleteUsers(selectedRowID)).then(() => handleDisplay());
  };

  const handleSaveChanges = () => {
    setGetUserData([]);
    let transformedArray = getUserData.map((item) =>
      selectedRowID.includes(item.userID) ? item : null
    );

    const filtered = transformedArray.filter((item) => item !== null);

    const rowsToEdit = filtered.map((obj) => {
      const { userID, roleID, geoID } = obj;
      return { userID, roleID, geoID, isInsert: "PartialUpdate" };
    });

    for (let i = 0; i < rowsToEdit.length; i++) {
      if (rowsToEdit[i].geoID == "") {
        rowsToEdit[i].geoID = countries
          .map((item) => item.countryID)
          .toString();
      }
    }

    dispatch(SaveUser(rowsToEdit)).then(() => handleDisplay());
  };

  const onRowsSelectionHandler = (ids) => {
    if (ids.length > 0) setShowButton(true);
    else setShowButton(false);

    setSelectedRowID(ids);
  };

  const columns = [
    {
      field: "fullName",
      headerName: "User Names",
      flex: 1.8,
      valueGetter: (value) => {
        return `${value.row.firstName || ""}${value.row.lastName || ""}`;
      },
    },
    {
      field: "userID",
      headerName: "User Number",
      flex: 1.5,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "firstName",
      headerName: "First Name",
      flex: 1.5,
    },

    {
      field: "lastName",
      headerName: "Last Name",
      flex: 1.5,
    },

    {
      field: "email",
      headerName: "Email",
      flex: 3,
    },

    {
      field: "activeFlag",
      headerName: "Status",
      flex: 2,
      headerAlign:"center",
      align: "center",
      renderCell: (params) => {
        const flag = params.value || "";
        const isActive = flag === "Y";
        const isInactive = flag === "N";
    
        return (
          <Box
            sx={{
              bgcolor:isActive ? "#F8E9E7" :"grey.lighter",
              color:isActive ? "darkred.light":"#000000",
              borderRadius: "20px",
              padding: "4px 12px",
              display:"inline-flex",
              alignItems:"center",
              justifyContent:"center",
              textAlign: "center",
              minWidth:"80px",
              height:"30px",
              fontWeight:'bold',
            }}
          >
            {isActive ? "Active" : isInactive ? "Inactive" : "Unknown"}
          </Box>
        );
      },
    },

    {
      field: "roleID",
      headerName: "SiMS Role",
      renderCell: (params) => {
        return <SelectBox params={params} />;
      },
      flex: 2.8,
    },

    {
      field: "userCountries",
      headerName: "Country",
      renderCell: (params) => {
        return <MultiSelect params={params} />;
      },
      flex: 5,
    },

    {
      field: "notfound",
      headerName: "Edit",
      flex: 1,
      renderCell: (params) => {
        return <EditUserFromGrid params={params} />;
      },
      sortable: false,
    },
  ];

  function EditUserFromGrid(params) {
    return <EditUser params={params} handleDisplay={handleDisplay} />;
  }

  function MultiSelect(params) {
    let id = params.params.row.userID;

    let geoIdList = null;
    if (params.params.row.geoID != "") {
      geoIdList = params.params.row.geoID;
      geoIdList = geoIdList.toString();
    }

    if (quantiRoleChange.roleChanged && quantiRoleChange.rowId == id) {
      geoIdList = null;
    }

    function handleCountrySelection(data) {
      let geoIdArray = countries.map((item) =>
        data.includes(item.countryName) ? item.countryID : null
      );
      let filteredGeoIdArray = geoIdArray.filter((item) => item !== null);
      // if (filteredGeoIdArray == "" || filteredGeoIdArray == []) {
      //   if(params.params.row.roleID === 1 || params.params.row.roleID=== 3|| params.params.row.roleID=== 5 ){
      //     filteredGeoIdArray = countries.map((item) => item.countryID);
      //   }       
      // }
      let finalData = getUserData.map((obj) =>
        obj.userID === id
          ? Object.assign(obj, { geoID: filteredGeoIdArray.toString() })
          : obj
      );
      //setGetUserData(finalData);
    }

    return (
      <MultiSelectCountry
        geoIdList={geoIdList}
        countryList={countries}
        sendDataToParent={handleCountrySelection}
        isEdit={true}
      ></MultiSelectCountry>
    );
  }

  function SelectBox(params) {
    let id = params.params.row.userID;

    const [selectedItem, setSelectedItem] = useState(params.params.row.roleID);

    const handleSelect = (event) => {
      setSelectedItem(event.target.value);
      if (
        event.target.value == 1 ||
        event.target.value == 3 ||
        event.target.value == 5
      )
        setQuantiRoleChange({ roleChanged: true, rowId: id });
      else setQuantiRoleChange({ roleChanged: false, rowId: null });

      const updatedGetUser = getUserData.map((obj) =>
        obj.userID === id
          ? Object.assign(obj, { roleID: event.target.value })
          : obj
      );

      setGetUserData(updatedGetUser);
    };
    return (
      <Select
        sx={{ width: 250, fontSize: "14px", height: "42px !important" }}
        value={selectedItem}
        onChange={handleSelect}
      >
        {roles.map((item) => (
          <MenuItem
            sx={{ fontSize: " 14px" }}
            key={item.roleID}
            value={item.roleID}
          >
            {item.roleName}
          </MenuItem>
        ))}
      </Select>
    );
  }

  return (
    <>
    {/* <CollapseSection title="User Adminstration"> */}
      <br />
      <div style={{fontWeight:'bold',marginTop:1}} className="text-primary">
        User Administration
      </div>

      <AddUserModal handleDisplay={handleDisplay} />
      {/* <Divider sx={{ mb: 2 }} /> */}
      <Box mt={3}>
        <Grid
          container
          columns={12}
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
          pb={1}
        >
          <Grid item xs={6} sm={3} md={4} lg={4}>
            <TextField
              variant="outlined"
              label="Country"
              select={countries.length > 0 ? true : false}
              value={countries.length > 0 ? selectedCountry : ""}
              onChange={handleCountryChange}
              fullWidth
              size="small"
            >
              <MenuItem key="0" value={"All"}>
                {"All"}
              </MenuItem>
              {countries.length > 0
                ? countries.map((country, index) => {
                    return (
                      <MenuItem
                        key={country.countryID}
                        value={country.countryName}
                      >
                        {country.countryName}
                      </MenuItem>
                    );
                  })
                : null}
            </TextField>
          </Grid>
          <Grid item xs={6} sm={3} md={3} lg={2.8}>
            <TextField
              variant="outlined"
              label="Role"
              select={roles.length > 0 ? true : false}
              value={roles.length > 0 ? selectedRole : ""}
              onChange={handleRoleChange}
              fullWidth
              size="small"
            >
              <MenuItem key="0" value={"All"}>
                {"All"}
              </MenuItem>
              {roles.length > 0
                ? roles.map((role, index) => {
                    return (
                      <MenuItem key={role.roleID} value={role.roleName}>
                        {role.roleName}
                      </MenuItem>
                    );
                  })
                : null}
            </TextField>
          </Grid>
          <Grid item xs={6} sm={3} md={4} lg={4}>
            <TextField
              variant="outlined"
              label="Search"
              value={searchText}
              onChange={handleSearchText}
              fullWidth
              size="small"
            ></TextField>
          </Grid>

          <Grid item xs={12} sm={3} md={1} lg={1.2}>
            <Box justifyContent="center" display="flex">
              <Button variant="contained" onClick={handleDisplay} size="large"
               sx={{
                bgcolor: "darkred.light",
                color: "white.main",
                textTransform: "none",
                fontWeight: "bold",
                "&:hover": {
                  bgcolor: "darkred.main",
                  color: "white.main",
                },
              }}>
                Search
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress />
      </Backdrop>
      <SharedComponent />
      {clearUserAdminData && (
        <Box
        mt={2}
        sx={{
          width: "100%",
          minHeight: "200px",
          display: getUserData ? "block" : "none",
        }}
      >
        <DataGridPro
          style={{ maxHeight: "calc(100vh - 130px)" }}
          disableColumnMenu
          sx={{
            "& .MuiDataGrid-columnHeaderTitle": {
              whiteSpace: "normal",
              lineHeight: "normal",
              fontWeight:"bold",
              fontSize:"15px"
            },
            "& .MuiDataGrid-columnHeader": {
              position: "sticky",
            },
            "& .MuiDataGrid-columnHeaders": {
              maxHeight: "168px !important",
            },
            // "& .MuiDataGrid-footerContainer": {
            //   justifyContent:"flex-start",
            // },
          }}
          rowHeight={70}
          rows={getUserData || []}
          columns={columns}
          getRowId={(row) => row?.userID}
          onRowSelectionModelChange={(ids) => onRowsSelectionHandler(ids)}
          initialState={{
            pagination: { paginationModel: { pageSize:20, page:0 }}
          }}
          pagination
          pageSizeOptions={[20, 50, 100, { value: muiConfig.DataGrid_All , label: 'All' }]}	
          checkboxSelection
          disableRowSelectionOnClick
        />
      </Box>
      )}
      
      <Box my={2} />
      <Grid
        container
        columns={12}
        justifyContent="flex-end"
        alignItems="right"
        my={2}
      >
        <Grid>
          {showButton && (
            <Button
              variant="contained"
              sx={{
                mr: 3, 
                mt: 2,
                bgcolor: "darkred.light",
                color: "white.main",
                textTransform: "none",
                fontWeight: "bold",
                "&:hover": {
                  bgcolor: "darkred.main",
                  color: "white.main",
                },
              }}
              onClick={handleDeactivateUser}
            >
              Deactivate selected user(s)
            </Button>
          )}
          {showButton && (
            <Button
              variant="contained"
              sx={{
                mt: 2,
                bgcolor: "darkred.light",
                color: "white.main",
                textTransform: "none",
                fontWeight: "bold",
                "&:hover": {
                  bgcolor: "darkred.main",
                  color: "white.main",
                },
              }}
              onClick={handleSaveChanges}
            >
              Save Changes
            </Button>
          )}
        </Grid>
      </Grid>
    {/* </CollapseSection> */}
    </>
  );
}
